<template lang="html">
    <div class="container-fluid p-5">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        လမ်းညွှန်
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th v-for="(value, key) in columns"
                                                    v-bind:class="{ 'asc': filter.sort == key && filter.reverse == 'desc', 'desc': filter.sort == key && filter.reverse == 'asc' }">
                                                    <a href="#" @click="sortBy(key)" class="text-capitalize">
                                                        {{value}}
                                                    </a>
                                                </th>
                                                <th class="th-width-100">ဓာတ်ပုံ</th>
                                                <th class="th-width-100">အမျိုးအစား</th>
                                                <th class="th-width-100">ဖုန်းနံပါတ်</th>
                                                <th class="th-width-100">လိပ်စာ</th>
                                                <th class="th-width-100">အပြည့်အစုံရေးရန် (MM)</th>
                                                <th class="th-width-100">အပြည့်အစုံရေးရန် (EN)</th>
                                                <!-- <th class="th-width-100">Pinned</th> -->
                                                <th class="th-width-100"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(data,index) in dataList">
                                                <td>{{data.title}}</td>
                                                <td><img :src="env.mediaUrl+data.image" class="tbl_image"/></td>
                                                <td>{{data.type}}</td>
                                                <td>{{data.phone}}</td>
                                                <td>{{data.address}}</td>
                                                <td style="padding: 0px;">
                                                     <button class="btn btn-option text-primary" @click="directoryDetail(data)"> 
                                                        <i class="fas fa-blog"></i>
                                                    </button>
                                                </td>
                                                <td style="padding: 0px;">
                                                     <button class="btn btn-option text-primary" @click="directoryDetailEn(data)"> 
                                                        <i class="fas fa-blog"></i>
                                                    </button>
                                                </td>
                                                 <!-- <td>
                                                    <button class="btn btn-option text-dafault" @click="changeDafault(data)" v-if="data.pin_status == 0">
                                                        <i class="fas fa-toggle-off"></i>
                                                    </button>
                                                    <button class="btn btn-option text-success" v-if="data.pin_status == 1">
                                                        <i class="fas fa-toggle-on" @click="changeDafault(data)"></i>
                                                    </button>
                                                </td> -->
                                                <td style="padding: 0px;">
                                                    <button class="btn btn-option text-primary"
                                                        @click="editData(data)"><i class="fas fa-edit"></i></button>
                                                    <button v-b-modal.bv-modal-delete
                                                        class="btn btn-option text-danger"><i
                                                            class="fas fa-trash-alt" @click="deleteData(data)"></i></button>
                                                </td>
                                            </tr>
                                            <tr v-if="dataList.length <= 0 ">
                                                <td colspan="7" class="text-center">Empty List</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <nav v-if="dataList.length > 0 " class="table_info">
                                        Showing {{metaData.from}} to {{metaData.to}} of {{metaData.total}} entries
                                    </nav>
                                    <nav class="paging_simple_numbers">
                                        <ul class="pagination pagination-md">
                                            <li class="page-item"
                                                :class="{ 'disabled': metaData.prev_page_url === null }">
                                                <a href="#" class="page-link" @click="next(metaData.current_page-1)">
                                                    &laquo;
                                                </a>
                                            </li>
                                            <li class="page-item" v-for="page in metaData.last_page" :key="page"
                                                :class="{ 'active':metaData.current_page === page }"
                                                v-if="Math.abs(page - metaData.current_page) < 3 || page == metaData.total - 1 || page == 0">
                                                <a href="#" @click.prevent="next(page)" class="page-link">
                                                    {{ page }}
                                                </a>
                                            </li>
                                            <li class="page-item"
                                                :class="{ 'disabled': metaData.current_page === metaData.last_page }">
                                                <a href="#" class="page-link" @click="next(metaData.current_page+1)">
                                                    &raquo;
                                                </a>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="bv-modal-delete" ref="my-modal" title="ဖျက်ရန်" hide-footer>
            <p class="my-4">ဖျက်ရန် သေချာပြီလား ? </p>
            <b-button class="mt-3 btn-danger" block @click="deleteItem()">ဖျက်မည်</b-button>
        </b-modal>
        <b-modal id="bv-modal-search" ref="my-modal" hide-footer>
            <template v-slot:modal-name>
                ရှာရန်
            </template>
            <div class="d-block text-center">
                <input class="form-control" placeholder="လမ်းညွှန် ခေါင်းစီး" v-model="filter.title">
            </div>
            <b-button class="mt-3 btn-success" block @click="search()">လုပ်ဆောင်မည်</b-button>
            <b-button class="mt-1 btn-info" block @click="reset()">အသစ်ပြန်စမည်</b-button>
        </b-modal>
        <router-link class="float-filter" to="" v-b-modal.bv-modal-search>
            <i class="fa fa-filter my-float" style="padding: 37%;bottom: 50px;"></i>
        </router-link>
        <router-link class="float" to="directory-create">
            <i class="fa fa-plus my-float" style="padding: 37%;"></i>
        </router-link>
    </div>
</template>

<script lang="js">
    import {
        mapState,
        mapActions
    } from 'vuex'
    import env from '../../enviorments'
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
        name: 'directoryList',
        metaInfo: {
            title: "Directory List",
            titleTemplate: "%s ← SC Dashboard",
        },
        components: {
            Loading
        },
        data() {
            return {
                env,
                isLoading: false,
                fullPage: true,
                alert: "",
                id: '',
                dataList: [],
                columns: {
                    title: "လမ်းညွှန် ခေါင်းစီး",
                },
                filter: {
                    page: 1,
                    reverse: "asc",
                    sort: "created_at",
                    title: "",
                },
                metaData: {
                    last_page: null,
                    current_page: 1,
                    from: null,
                    to: null,
                    total: null,
                    prev_page_url: null
                }
            }
        },
        watch: {
        '$route' (to, from) {
            this.fetchData()
        }
    },
        computed: {},
        methods: {
            ...mapActions({
                directoryListAction: 'directoryListAction',
                directoryDeleteAction: 'directoryDeleteAction',
                directoryPinStatusAction: 'directoryPinStatusAction',
            }),
            sortBy(column) {
                this.filter.sort = column
                if (this.filter.sort == column) {
                    if (this.filter.reverse == "asc") {
                        this.filter.reverse = "desc"
                    } else if (this.filter.reverse == "desc") {
                        this.filter.reverse = "asc"
                    }
                } else {
                    this.filter.reverse = "asc"
                }
                this.fetchData()
            },
            async search() {
                this.filter.page = 1
                this.fetchData()
                this.$refs['my-modal'].hide()
            },
            async fetchData() {
                this.isLoading = true
                let option = this.filter
                await this.directoryListAction({
                    ...option
                }).then(res => {
                    if (res.status == "success") {
                        this.dataList = res.data.data
                        this.metaData.last_page = res.data.meta.last_page
                        this.metaData.current_page = res.data.meta.current_page
                        this.metaData.prev_page_url = res.data.links.prev
                        this.metaData.from = res.data.meta.from
                        this.metaData.to = res.data.meta.to
                        this.metaData.total = res.data.meta.total
                        this.$router.replace({ path: 'directory-list', query: { page: this.filter.page, reverse: this.filter.reverse, sort: this.filter.sort, title: this.filter.title} }).catch(()=>{})
                        this.isLoading = false;
                    }
                }).catch(err => this.isLoading = true)
            },
            next: function (page) {
                this.filter.page = page
                this.fetchData();
            },
            reset(){
                this.$router.replace({ path: 'directory-list', query: {page: 1, reverse: 'desc', sort: 'created_at', title: ''} }).catch(()=>{})
                 this.$router.go()
            },
            editData(data) {
                this.$router.replace({ path: 'directory-edit', query: { page: this.filter.page, reverse: this.filter.reverse, sort: this.filter.sort, id: data.id, title: this.filter.title } }).catch(()=>{})
            },
            directoryDetail(data) {
                this.$router.replace({ path: 'directory-detail', query: { page: this.filter.page, reverse: this.filter.reverse, sort: this.filter.sort, id: data.id, title: this.filter.title } }).catch(()=>{})
            },
            directoryDetailEn(data) {
                this.$router.replace({ path: 'directory-detail-en', query: { page: this.filter.page, reverse: this.filter.reverse, sort: this.filter.sort, id: data.id, title: this.filter.title } }).catch(()=>{})
            },
            deleteData(data){
                this.id = data.id
            },
            async deleteItem() {
				this.isLoading = true
				let option = {
					id: this.id,
				}
				await this.directoryDeleteAction({
					...option
				}).then(res => {
					this.fetchData()
                    this.$refs['my-modal'].hide()
                    this.isLoading = false;
				}).catch(err => this.isLoading = true)
			},
            async changeDafault(data) {
				this.isLoading = true
				let option = {
					id: data.id,
				}
				await this.directoryPinStatusAction({
					...option
				}).then(res => {
					this.fetchData()
                    this.isLoading = false;
				}).catch(err => this.isLoading = true)
			},

        },
        mounted() {
            this.filter.page = this.$route.query.page
            this.filter.reverse = this.$route.query.reverse
            this.filter.sort = this.$route.query.sort
            this.filter.title = this.$route.query.title
            this.fetchData()
        }
    }
</script>

<style scoped lang="scss">
    .action {
        border: none;
        background: none;
        font-size: 24px;
    }
</style>